module.exports = __webpack_public_path__ + "static/media/slide2.3645df12.png";